/** Collapsed summary line for a memory activity cluster. */
export function buildMemoryClusterSummary(
  subType: 'retrieved' | 'stored' | undefined,
  count: number,
): string {
  const n = Math.max(1, count);
  const memoryWord = n === 1 ? 'Memory' : `${n} memories`;
  const verb = subType === 'stored' ? 'recorded' : 'recalled';
  return `${memoryWord} ${verb}`;
}
